import { render, staticRenderFns } from "./ScrapingServiceTable.vue?vue&type=template&id=efc4f2c2&"
import script from "./ScrapingServiceTable.vue?vue&type=script&lang=js&"
export * from "./ScrapingServiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports